/** Whether the stages after the Thesis are open, as the server reads it. */

import type { StageGateResponse } from "@patent-studio/api-types";
import { get } from "@/services/api-client";

export function stageGate(taskId: string): Promise<StageGateResponse> {
  return get<StageGateResponse>(`/tasks/${taskId}/gate`);
}
